import {
    Component,
    EventEmitter,
    Inject,
    NgZone,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import { Store } from 'redux';
import { tap } from 'rxjs/operators';

import {
    takeUntilDestroy,
    TakeUntilDestroy,
} from '../common/take-until-destroy.decorator';
import { Category, DefinitionSummary } from '../insight/config.insight.model';
import { Tab } from '../insight/experimental.tabset';
import {
    rootListDefinitionSummary,
    rootSelectLevelOption,
} from '../insight/insight.action';
import { storeObserver } from '../store';
import { STORE } from '../store.metadata';

import { TranslationKeyMap } from './performance-insight.i18n';
import { createTab } from './performance-insight.model';
import { RootState, storeStateMapper } from './performance-insight.state';

@Component({
    selector: '[cmpsPerformanceInsightWizard]',
    templateUrl: './wizard.pi.component.html',
})
@TakeUntilDestroy()
export class WizardPerformanceInsightComponent implements OnInit, OnDestroy {
    i18n = TranslationKeyMap;
    state: RootState;

    @Output()
    tabCreate: EventEmitter<Tab>;

    constructor(
        private readonly _ngZone: NgZone,
        @Inject(STORE) private readonly _store: Store,
    ) {
        this.tabCreate = new EventEmitter();
    }

    ngOnInit(): void {
        storeObserver<any, RootState>(this._store, storeStateMapper)
            .pipe(
                tap((state) =>
                    this._ngZone.run(() => {
                        const prevState = this.state;
                        this.state = state;
                        this.stateToProps(prevState);
                    }),
                ),
                takeUntilDestroy(this),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this.tabCreate.complete();
    }

    stateToProps(prevState?: RootState): void {
        if (!prevState) {
            this.propsToDispatch();
            // eslint-disable-next-line no-useless-return
            return;
        }
    }

    propsToDispatch(): void {
        this._store.dispatch(rootListDefinitionSummary(['pi']));
    }

    onCategoryChange($event: Category): void {
        this._store.dispatch(rootSelectLevelOption($event, null, null));
    }

    onSubCategoryChange($event: Category): void {
        this._store.dispatch(rootSelectLevelOption(null, $event, null));
    }

    onDefinitionChange($event: DefinitionSummary): void {
        this._store.dispatch(rootSelectLevelOption(null, null, $event));
    }

    onAddClick(): void {
        const tab = createTab(
            this.state.activeDefinition.definitionIdentifier,
            this.state.activeCategory.name ||
                this.state.activeCategory.shortName,
            this.state.activeSubCategory &&
                (this.state.activeSubCategory.name ||
                    this.state.activeSubCategory.shortName),
            this.state.activeDefinition.name ||
                this.state.activeDefinition.shortName,
        );
        this.tabCreate.emit(tab);
    }
}
